angular.module('tasks').directive('taskCardDetails', ["$timeout", "$modal", "PATH", "taskManagementService", "localStorageService", "personService", function ($timeout, $modal, PATH, taskManagementService, localStorageService, personService) {
  return {
    restrict: 'E',
    scope: {
      activeCard: '=',
      cardId: '=',
      onClose: '&',
      onStatusChange: '&',
      onMembersChange: '&'
    },
    templateUrl: PATH.components + 'taskManagement/cardDetails/view.html',
    link: function ($scope) {
      $scope.managers = {};

      var userInfo = localStorageService.get('userInfo');
      taskManagementService.refreshTask($scope.cardId).then(function (response) {
        updateScopeCardData(response.data);
      });
      taskManagementService.getStoreTeamAndPlans($scope.activeCard.store.id)
        .then(function (response) {
          var data = response.data;
          $scope.plans = data.stripeCustomer
            && data.stripeCustomer.subscriptions
            && data.stripeCustomer.subscriptions.data[0]
            && data.stripeCustomer.subscriptions.data[0].items.data
            .map(function (plan) {
              return plan.plan && plan.plan.metadata && plan.plan.metadata.title;
            });
          delete data.stripeCustomer;
          $scope.managers = data;
          var transactionRedirects = document.querySelectorAll('.transaction-redirect');
          if (transactionRedirects.length > 0) {
            var panelContent = document.querySelector('.panel-new__content.panel-new__line');
            panelContent.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              $scope.slideIn('transactions#/transaction/' + event.target.getAttribute('transactionid'), $scope.activeCard.store.id, $scope.activeCard.primaryUserId);
            });
          }
        });

      $scope.userInfo = userInfo.person;
      $scope.adminsList = taskManagementService.adminsList;
      $scope.loading = false;
      $scope.statusPlaceholder = {};

      $scope.slideIn = function (transactions, storeId, primaryUserId) {
        var user = localStorageService.get('userInfo');

        $scope.loading = true;
        if (transactions) {
          personService.slideIn(userInfo, { id: parseInt(primaryUserId) }, storeId, transactions);
        } else {
          personService.slideIn(
            { login: user.login, companyid: $scope.activeCard.companyId, role: user.role, id: user.id },
            { id: $scope.activeCard.primaryUserId },
            $scope.activeCard.store.id
          );
        }
      };

      $scope.filterAdminList = function () {
        return _.filter($scope.adminsList, function (admin) {
          return !(_.find($scope.card ? $scope.card.members : [], function (member) {
            return member.id == admin.id;
          }));
        });
      };

      function updateScopeCardData(card) {
        $scope.card = card;
        $scope.card.statusNew = $scope.card.status;
        $scope.card.comments.map(function (comment) {
          comment.time = comment.createTime;
          comment.activityType = 'comment';
          $scope.card.activity.push(comment);
        });

        checkAllItemsComplete();
      }

      var NEEDS_PROCESSING_STATUS = 1;
      var NEEDS_REVIEW_STATUS = 3;


      $scope.cardStatusOptionsDefault = [
        { value: 0, caption: '<span class="status-label s0">Needs Research</span>' },
        { value: NEEDS_PROCESSING_STATUS, caption: '<span class="status-label s1">Needs Processing</span>' },
        { value: NEEDS_REVIEW_STATUS, caption: '<span class="status-label s3">Needs Review</span>' }
      ];
      $scope.cardStatusOptions = angular.copy($scope.cardStatusOptionsDefault);
      $scope.isStatusPickerVisible = function () {
        return $scope.card && $scope.statusPlaceholder.value && (
          $scope.card.statusNew !== 3 ||
          personService.isSuperman(userInfo)
        );
      };

      $scope.canBeApproved = function (card) {
        return card && (card.type === 'weeklyreporting' || card.type === 'periodreporting') &&
          !isCardDone() &&
          personService.isSuperman(userInfo);
      };

      $scope.canBeReopened = function () {
        return isCardDone() && personService.isSuperman(userInfo);
      };

      $scope.canBeClosed = function (card) {
        return card && card.type === 'transactionsupport' &&
          !isCardDone() &&
          personService.isSuperman(userInfo);
      };

      $scope.closeCard = function (skipUpdateStatusCardOnClose) {
        if (!skipUpdateStatusCardOnClose) {
          $scope.changeCardStatus($scope.card.status, true);
        }
        $scope.onClose();
      };
      $scope.changeCardStatus = function (newStatus, isConfirmed) {
        if ($scope.card.status === 4 && !isConfirmed) {
          openConfirmModal(newStatus);
          return;
        }
        $scope.onStatusChange({ card: $scope.card, newStatus: newStatus }).then(function (res) {
          var skipUpdateStatusCardOnClose = true;
          updateScopeCardData(res);
          if (newStatus == 4) {
            $scope.closeCard(skipUpdateStatusCardOnClose);
            setStatusPlaceholder();
          }
        });
      };

      function openConfirmModal(newStatus) {
        var scope = $scope.$new(true);
        var modal = $modal({
          scope: scope,
          templateUrl: PATH.components + 'taskManagement/cardDetails/modal.delete.html'
        });
        scope.title = 'Re-open ' + moment($scope.card.endDateString).format('MMMM');
        scope.reason = { value: '' };
        scope.save = function (value) {
          if (value) {
            $scope.changeCardStatus(newStatus, true);
            $scope.commentAdded('Re-Open Reason: ' + value, true);
            modal.hide();
          }
        };
        scope.cancel = function () {
          modal.hide();
        };
      }

      function setStatusPlaceholder() {
        $scope.statusPlaceholder.value = undefined;
        $timeout(function () {
          $scope.statusPlaceholder.value = isCardDone()
            ? 'Reopen ' + moment($scope.card.endDateString).format('MMMM')
            : 'Change Status';
        }, 100);
      }

      $scope.removeComment = function (comment) {
        taskManagementService.deleteComment(comment.id).then(function () {
          _.remove($scope.card.comments, function (iterationComment) {
            return iterationComment.id == comment.id;
          });
          _.remove($scope.card.activity, function (activity) {
            return activity.activityType == 'comment' && activity.id == comment.id;
          });
        });
      };
      $scope.updateComment = function (comment, mentions, oldMentions) {
        taskManagementService.updateComment(comment.comment, comment.id, mentions, oldMentions);
      };
      $scope.commentAdded = function (comment, isDisabled, mentionedUsers) {
        taskManagementService.addComment(comment, $scope.card.id, isDisabled, mentionedUsers)
          .then(function (comment) {
            comment.time = comment.createTime;
            comment.activityType = 'comment';
            $scope.card.activity.push(comment);
          });
      };
      $scope.checklistItemChanged = function (item) {
        item.isOpen = !item.completed;
        taskManagementService.updateTaskItem(item).then(function (response) {
          var record = response.data;
          record.activity.taskItem = item;
          $scope.card.activity.push(record.activity);
          if (!$scope.allItemsNotComplete && $scope.card.status === NEEDS_PROCESSING_STATUS) {
            $scope.changeCardStatus(NEEDS_REVIEW_STATUS);
          }
          if ($scope.card.status === 0) {
            var processingChecklist = _.find($scope.card.checklists, { name: 'Processing Checklist' });
            var isProcessingChecklistComplete = !_.find(processingChecklist.items, { isOpen: true });
            if (isProcessingChecklistComplete) {
              $scope.changeCardStatus(NEEDS_PROCESSING_STATUS);
            }
          }
        });
      };

      function checkAllItemsComplete() {
        var incompleteItems = $scope.card.checklists.reduce(function (sum, checklist) {
          return sum + checklist.items.reduce(function (sum, value) {return sum + value.isOpen ? 1 : 0;}, 0);
        }, 0);
        $scope.allItemsNotComplete = incompleteItems > 0;
        if ($scope.allItemsNotComplete) {
          $scope.cardStatusOptions = _.filter($scope.cardStatusOptionsDefault, function (item) {
            return item.value != 3;
          });
        } else {
          $scope.cardStatusOptions = angular.copy($scope.cardStatusOptionsDefault);
        }
        setStatusPlaceholder();
      }

      $scope.isCardDone = isCardDone;

      function isCardDone() {
        var DONE_STATUS = 4;
        return $scope.card && $scope.card.status === DONE_STATUS;
      }

      $scope.showMemberContext = function (member, event) {
        $scope.card.members.map(function (member) {
          $scope.hideMemberContext(member);
        });
        member.showOptions = true;
        event.stopPropagation();
        event.preventDefault();
      };
      $scope.hideMemberContext = function (member, event) {
        member.showOptions = false;
        if (event) {
          event.stopPropagation();
          event.preventDefault();
        }
      };
      $scope.showAddMemberContext = function (event) {
        $scope.showAddMember = true;
        $scope.newMemberSearch = '';
        event.stopPropagation();
        event.preventDefault();
      };
      $scope.hideAddMemberContext = function (member, event) {
        $scope.showAddMember = false;
        if (event) {
          event.stopPropagation();
          event.preventDefault();
        }
      };
      $scope.removeMember = function (member, event) {
        taskManagementService.removeUserFromCard(member.id, $scope.card.id).then(function (response) {
          var data = response.data;
          $scope.card.activity.push(data);
          _.remove($scope.card.members, function (iterationMember) {
            return member.id == iterationMember.id;
          });
          $scope.onMembersChange({ cardId: $scope.cardId, members: $scope.card.members });
        });
        event.stopPropagation();
        event.preventDefault();
        $scope.hideMemberContext(member);
      };
      $scope.addMemberToCard = function (member, event) {
        taskManagementService.addMemberToCard(member.id, $scope.card.id).then(function (response) {
          var data = response.data;
          $scope.card.activity.push(data.activity);
          $scope.card.members.push(data.user);
          $scope.onMembersChange({ cardId: $scope.cardId, members: $scope.card.members });
        });
        event.stopPropagation();
        event.preventDefault();
        $scope.hideAddMemberContext();
      };
      $scope.$on('$typeahead.select', function (event, value, index, elem) {
        $scope.addMemberToCard(value, event);
        setTimeout(function () {
          $scope.hideAddMemberContext();
        }, 50);
      });
    }
  };
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/taskManagement/cardDetails/directive.js